export type PageProps = {
  children: React.ReactNode
};

export const maxPageWidth = '550px';

export const PageUI: React.FC<PageProps> = ({ children }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      maxWidth: maxPageWidth,
      // borderColor: colors.black,
      // borderStyle: 'solid',
      // borderWidth: '1px',
      // borderRadius: '10px',
      // margin: '0px auto',
      padding: '1em 0px 1em 0px',
      height: '100%',
      width: '100%',
    }}
    >
      {children}
    </div>
  );
};
